import { render, staticRenderFns } from "./static_block.vue?vue&type=template&id=a739ed2c&lang=pug"
import script from "./static_block.vue?vue&type=script&lang=js"
export * from "./static_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports